import React, { useEffect } from 'react';
import { Icon } from 'semantic-ui-react';

import { useLocation } from 'react-router-dom';
import { SearchWidget } from '@plone/volto/components';
import {
  Button,
  Dialog,
  DialogTrigger,
  Modal,
  ModalOverlay,
} from 'react-aria-components';

import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  close: {
    id: 'close-form-search',
    defaultMessage: 'Chiudere il modullo di ricerca',
  },
  site_search_title: {
    id: 'site_search_title',
    defaultMessage: 'Ricerca nel sito',
  },
  form_search: {
    id: 'form_search',
    defaultMessage: 'Modulo di ricerca',
  },
});

const HeaderSearch = () => {
  const intl = useIntl();
  const location = useLocation();
  let [isModalOpen, setModalOpen] = React.useState(false);
  useEffect(() => {
    if (isModalOpen) {
      document?.querySelector('.ui.form .searchbox.field input')?.focus();
    }
  }, [isModalOpen]);
  return (
    <div className="header-search">
      <DialogTrigger>
        <Button className="search-form-open" onPress={() => setModalOpen(true)}>
          <Icon name="search"></Icon>
          <span className="sr-only">
            {intl.formatMessage(messages.site_search_title)}
          </span>
        </Button>
        <ModalOverlay className="modal-overlay">
          <Modal isDismissable isOpen={isModalOpen} className="modal-wrapper">
            <Dialog>
              {({ close }) => {
                return (
                  <form aria-label={intl.formatMessage(messages.form_search)}>
                    <SearchWidget pathname={location.pathname} />
                    <Button
                      className="modal-close"
                      aria-label={intl.formatMessage(messages.close)}
                      onPress={() => {
                        close();
                        setModalOpen(false);
                      }}
                    >
                      <Icon name="close"></Icon>
                    </Button>
                  </form>
                );
              }}
            </Dialog>
          </Modal>
        </ModalOverlay>
      </DialogTrigger>
    </div>
  );
};

export default HeaderSearch;
